import React from 'react';
import { Container } from 'react-bootstrap';
import { Route, Switch, withRouter } from 'react-router';
import NotFound from '../../components/NotFound';
import CachedResponse from '../common/CachedResponse';
import ResourceLibrary from './ResourceLibrary';
import DeliverySetCalculator from './DeliverySetCalculator';
import MockPrint from '../doc-hub/MockPrint';
import {
  ROLE_ADMIN,
  ROLE_SALES,
  ROLE_SALES_AND_INVENTORY_MANAGER,
  ROLE_SALES_MANAGER,
  ROLE_SERVICE,
  ROLE_SUPER_ADMIN
} from '../../helpers/constants';
import { userHasAnyRole } from '../../helpers/roleHelpers';

const Utilities = ({ location }) => {
  if (location.pathname === '/utilities/resources') return <ResourceLibrary />;
  if (
    !userHasAnyRole(
      ROLE_SUPER_ADMIN,
      ROLE_ADMIN,
      ROLE_SALES,
      ROLE_SALES_MANAGER,
      ROLE_SERVICE,
      ROLE_SALES_AND_INVENTORY_MANAGER
    )
  ) {
    return <NotFound text="You are not authorized to view this page" />;
  }

  const getActivePage = () => {
    return (
      <Switch>
        <Route exact path="/utilities/commission-sheet">
          <CachedResponse
            listEndpoint={'app-choices'}
            render={appChoices => <MockPrint appChoices={appChoices} documentName="Commission Sheet" />}
          />
        </Route>
        <Route exact path="/utilities/sales-agreement">
          <CachedResponse
            listEndpoint={'app-choices'}
            render={appChoices => <MockPrint appChoices={appChoices} documentName="Sales Agreement" />}
          />
        </Route>
        {userHasAnyRole(
          ROLE_SUPER_ADMIN,
          ROLE_ADMIN,
          ROLE_SALES,
          ROLE_SALES_MANAGER,
          ROLE_SALES_AND_INVENTORY_MANAGER
        ) && (
          <Route exact path="/utilities/delivery-set-calculator">
            <CachedResponse
              listEndpoint={'app-choices'}
              render={appChoices => <DeliverySetCalculator appChoices={appChoices} />}
            />
          </Route>
        )}
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    );
  };

  return (
    <>
      <Container fluid className="px-2 px-md-5 py-2 h-100">
        {getActivePage()}
      </Container>
    </>
  );
};

export default withRouter(Utilities);
